import jsonGraphqlExpress from './jsonGraphqlExpress';
import schemaBuilder from './schemaBuilder';

export const jsonSchemaBuilder = schemaBuilder;
export default jsonGraphqlExpress;
